import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { Container, StyledH3 } from "./styled";
var NoExist = function (props) {
    var children = props.children, additionalElement = props.additionalElement;
    var idNamespace = id("no-exist", props);
    return (React.createElement(Container, { id: idNamespace },
        React.createElement(StyledH3, null, children || React.createElement(FormattedMessage, { id: "platform.layout.noExist.defaultText" })),
        additionalElement));
};
export default NoExist;
